// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__12SqF","label":"SetPasswdForm_label__PlW91"};